import script from "./SortThumb.vue?vue&type=script&setup=true&lang=js"
export * from "./SortThumb.vue?vue&type=script&setup=true&lang=js"

import "./SortThumb.vue?vue&type=style&index=0&id=5fb5e976&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fb5e976"]])

export default __exports__